import moment from "moment-timezone"
import { formatDbDate } from "../../common/utils/date-utils"

export const WINDOW_START_GRACE_MINUTES = 10
export const WINDOW_END_GRACE_MINUTES = 30

export function gotoOnlineSession(options: {
  sessionKey: string
}) {
  window.open(`/video-session/${options.sessionKey}`, `_blank`)
}

export function getOnlineSessionWindowStatus(options :{
  sessionISODateString: string,
  startTimeString: string,
  endTimeString: string,
  timezone: string;
}) {

  const format = 'YYYY-MM-DD';

  const now = moment();

  const sessionDateString = formatDbDate(options.sessionISODateString, format);

  const scheduledStartTime = moment.tz(sessionDateString, options.timezone);
  const [startHour, startMinute, startSecond] = options.startTimeString.split(':').map(Number);
  scheduledStartTime.set({ hour: startHour, minute: startMinute, second: startSecond });
  const allowedStartTime = scheduledStartTime.clone()
    .subtract(WINDOW_START_GRACE_MINUTES, 'minutes')
  const isWindowOpened = now.isAfter(allowedStartTime)

  const scheduledEndTime = moment.tz(sessionDateString, options.timezone);
  const [endHour, endMinute, endSecond] = options.endTimeString.split(':').map(Number);
  scheduledEndTime.set({ hour: endHour, minute: endMinute, second: endSecond });
  const allowedEndTime = scheduledEndTime.clone()
    .add(WINDOW_END_GRACE_MINUTES, 'minutes')
  const isWindowClosed = now.isAfter(allowedEndTime)


  const result = {
    opened: isWindowOpened,
    closed: isWindowClosed,
    available: isWindowOpened && !isWindowClosed,
    pastStartTime: now.isSameOrAfter(scheduledStartTime),
    pastEndTime: now.isSameOrAfter(scheduledEndTime),

  }

  return result
}